import { skillsData } from "./skillsData";
import { SkillCategory } from "./SkillCategory";

const SkillsSection = () => {
  return (
    <section id="skills" className="py-20 bg-secondary/30">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-4">Skills & Expertise</h2>
        <p className="text-center text-muted-foreground mb-12 max-w-2xl mx-auto">
          Technical stack and domain knowledge
        </p>

        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {Object.entries(skillsData).map(([category, skills], index) => (
            <SkillCategory key={category} category={category} skills={skills} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;
